import React, { useEffect, useState } from "react";
import Navbar from "../../component/common/NavbarProfile";
import AccessoryCard from "./AccessoryCard";
import { getProducts } from "../../handlers/common/api";
import { Button } from "antd";
import BackButton from "../../assets/images/backBtn.svg";
import { useNavigate, useLocation } from "react-router-dom";

const AccessoriesPage = () => {
  const [cartItems, setCartItems] = useState([]);
  const [venueData, setVenueData] = useState(null);
  const [rentalItems, setRentalItems] = useState([]);
  const [consumableItems, setConsumableItems] = useState([]);
  const [sp00Items, setSp00Items] = useState([]);
  const [showAll, setShowAll] = useState(true);
  const [isMobileView, setIsMobileView] = useState(false);
  const [bookingFor, setBookingFor] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      window.history.scrollRestoration = "manual";
      window.scrollTo(0, 0);
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [location]);

  useEffect(() => {
    window.history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
    
    const token = localStorage.getItem("venueData");
    if (token) {
      setVenueData(JSON.parse(token));
    }

    const items = JSON.parse(localStorage.getItem("cartItems")) || [];
    setCartItems(items);
    
    // Get booking_for from the first cart item
    if (items.length > 0 && items[0].booking_for) {
      setBookingFor(items[0].booking_for);
    }
  }, []);

const fetchRentalDetails = async () => {
  try {
    const requestBody = {
      item_group: "Rental"
    };
    
    if (bookingFor) {
      requestBody.booking_for = bookingFor;
    }

    const options = {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
      },
    };

    console.log("ACCESSORY REQUEST BODY", requestBody);
    
    const response = await fetch(`${getProducts}`, options);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Validate response structure
    if (!data || !Array.isArray(data.data)) {
      console.warn("Invalid API response format - expected data array");
      setRentalItems([]);
      return;
    }

    const optionList = data.data || []; // Fallback to empty array
    const filterinternal = optionList.filter(item => 
      item && item.is_internal === 0
    );
    
    const arr = [];
    for (let i = 0; i < filterinternal.length; i++) {
      if (filterinternal[i]?.price !== 0) {
        arr.push({
          name: filterinternal[i]?.name || 'Unknown',
          value: filterinternal[i]?.name || 'Unknown',
          label: filterinternal[i]?.name || 'Unknown',
          price: filterinternal[i]?.price || 0,
          image: filterinternal[i]?.image || '',
          per_minuts_price: filterinternal[i]?.per_minuts_price || 0,
          item_category: "Rental",
        });
      }
    }
    setRentalItems(arr);
  } catch (error) {
    console.error("Error fetching rental details:", error.message);
    setRentalItems([]); // Reset to empty array on error
  }
};

const fetchConsumableDetails = async () => {
  try {
    const requestBody = {
      item_group: "Products"
    };
    
    if (bookingFor) {
      requestBody.booking_for = bookingFor;
    }

    const options = {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
      },
    };
    
    const response = await fetch(`${getProducts}`, options);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Validate response structure
    if (!data || !Array.isArray(data.data)) {
      console.warn("Invalid API response format - expected data array");
      setConsumableItems([]);
      return;
    }

    const optionList = data.data || [];
    const filterinternal = optionList.filter(item => 
      item && item.is_internal === 0
    );
    
    const arr = [];
    for (let i = 0; i < filterinternal.length; i++) {
      if (filterinternal[i]?.price !== 0) {
        arr.push({
          name: filterinternal[i]?.name || 'Unknown',
          value: filterinternal[i]?.name || 'Unknown',
          label: filterinternal[i]?.name || 'Unknown',
          price: filterinternal[i]?.price || 0,
          image: filterinternal[i]?.image || '',
          per_minuts_price: filterinternal[i]?.per_minuts_price || 0,
          item_category: "Products",
        });
      }
    }
    setConsumableItems(arr);
  } catch (error) {
    console.error("Error fetching consumable details:", error.message);
    setConsumableItems([]);
  }
};

const fetchSP002Details = async () => {
  try {
    const requestBody = {
      item_group: "Services Products 002"
    };
    
    if (bookingFor) {
      requestBody.booking_for = bookingFor;
    }

    const options = {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await fetch(`${getProducts}`, options);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Validate response structure
    if (!data || !Array.isArray(data.data)) {
      console.warn("Invalid API response format - expected data array");
      setSp00Items([]);
      return;
    }

    const optionList = data.data || [];
    const filterinternal = optionList.filter(item => 
      item && item.is_internal === 0
    );
    
    const arr = [];
    for (let i = 0; i < filterinternal.length; i++) {
      if (filterinternal[i]?.price !== 0) {
        arr.push({
          name: filterinternal[i]?.name || 'Unknown',
          value: filterinternal[i]?.name || 'Unknown',
          label: filterinternal[i]?.name || 'Unknown',
          price: filterinternal[i]?.price || 0,
          image: filterinternal[i]?.image || '',
          per_minuts_price: filterinternal[i]?.per_minuts_price || 0,
          item_category: "services_products_002",
        });
      }
    }
    setSp00Items(arr);
  } catch (error) {
    console.error("Error fetching SP002 details:", error.message);
    setSp00Items([]);
  }
};

  // Update useEffect to include bookingFor dependency
  useEffect(() => {
    if (bookingFor !== null) {
      fetchRentalDetails();
      fetchConsumableDetails();
      fetchSP002Details();
    }
  }, [bookingFor]);

  // Rest of the component remains the same...
  const checkIfMobile = () => {
    setIsMobileView(window.innerWidth <= 768);
  };

  const handleSeeMore = () => {
    setShowAll(!showAll);
  };

  useEffect(() => {
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  const handleProceedToCheckout = () => {
    navigate("/viewcart");
  };
  
  const handleBack = () => {
    if (location.key !== "default") {
      navigate(-1);
    } else {
      navigate(`/`);
    }
  };

  return (
    <>
      <Navbar />
      <div className="max-w-full justify-between items-center py-4 px-6 lg:px-20">
        <header className="mb-4 relative">
          <div className="flex flex-col md:flex-row justify-between">
            <div className="col-lg-8 w-full cart-wrap">
              <button onClick={handleBack} className="backBtn ">
                <img
                  className="rounded-full nav-profile-pic"
                  src={BackButton}
                  alt="ProfileImage"
                />
                Back
              </button>

              <div className="">
                <div className="flex">
                  <div>
                    <h1 className="text-3xl mt-4 font-bold text-start mb-0">
                      {venueData?.data?.venue_name}
                    </h1>
                    <p className="mt-0 text-slate-500 text-xs">
                      {venueData?.data?.address}
                    </p>
                  </div>
                  <div className="mt-4 px-6">
                    {!isMobileView && (
                      <button
                        className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                        onClick={handleProceedToCheckout}
                      >
                        Proceed to Checkout
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {isMobileView && (
                <Button
                  onClick={handleProceedToCheckout}
                  className="cartBtn"
                  style={{ position: "fixed", right: "20px", zIndex: 1000 }}
                >
                  <span>Proceed to Checkout</span>
                </Button>
              )}
            </div>
          </div>
        </header>
        <div className="mt-8">
          <div className="flex justify-between">
            <div>
              <h1 className="font-bold text-4xl">Add Accessories</h1>
            </div>
            <div>
              {rentalItems.length > 3 && (
                <>
                  {/* <div className=" ">
                    <button onClick={handleSeeMore} className="text-red-500">
                      {showAll ? "See Less" : "See More"}
                    </button>
                  </div> */}
                </>
              )}
            </div>
          </div>
          <div>
            {rentalItems.length > 0 && (
              <h1 className="font-bold text-2xl mt-2 mb-4">Rental Items</h1>
            )}{" "}
            <div className="flex flex-wrap justify-center sm:justify-start lg:justify-start mb-10">
              {rentalItems
                .slice(0, showAll ? rentalItems.length : 3)
                .map((item, index) => (
                  <AccessoryCard
                    key={index}
                    {...item}
                    nonrental={false}
                    cartItems={cartItems}
                    setCartItems={setCartItems}
                    className="lg:w-1/4 md:w-1/2 sm:w-full"
                  />
                ))}
            </div>
          </div>{" "}
          {consumableItems.length > 0 && (
            <h1 className="font-bold text-2xl mb-4">Consumable Items</h1>
          )}{" "}
          <div>
            <div className="flex flex-wrap justify-center sm:justify-start lg:justify-start mb-10">
              {consumableItems
                .slice(0, showAll ? consumableItems.length : 3)
                .map((item, index) => (
                  <AccessoryCard
                    key={index}
                    {...item}
                    nonrental={true}
                    cartItems={cartItems}
                    setCartItems={setCartItems}
                    className="lg:w-1/4 md:w-1/2 sm:w-full"
                  />
                ))}
            </div>
          </div>
          {sp00Items.length > 0 && (
            <h1 className="font-bold text-2xl mb-4">Service Items</h1>
          )}{" "}
          <div>
            <div className="flex flex-wrap justify-center sm:justify-start lg:justify-start mb-10">
              {sp00Items
                .slice(0, showAll ? sp00Items.length : 3)
                .map((item, index) => (
                  <AccessoryCard
                    key={index}
                    {...item}
                    nonrental={true}
                    cartItems={cartItems}
                    setCartItems={setCartItems}
                    className="lg:w-1/4 md:w-1/2 sm:w-full"
                  />
                ))}
            </div>
          </div>
          <div className=" flex ">
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded z-10"
              onClick={handleProceedToCheckout}
            >
              Proceed to Checkout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccessoriesPage;
